//This file should export all hooks from hooks folder
export { useMediaQuery } from './useMediaQuery';
